export const collagen = ["collage-kita-hub-bayern-002.webp","collage-kita-hub-bayern-003.webp","collage-kita-hub-bayern-004.webp"];